"use client";

import { c as _c } from "react/compiler-runtime";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from "chart.js";
import { cssVar } from "@/lib/colours";
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);
type Activity = {
  id: string;
  type: "feeding" | "pooping" | "wee" | "sleeping";
  time: Date;
  startTime?: Date;
  endTime?: Date;
  notes?: string;
};
type BabyTrackerGraphProps = {
  activities: Activity[];
};
export default function BabyTrackerGraph(t0) {
  const $ = _c(8);
  const {
    activities
  } = t0;
  let t1;
  if ($[0] !== activities) {
    const processData = () => {
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
      const filteredActivities = activities.filter(activity => new Date(activity.time) >= sevenDaysAgo);
      const sortedActivities = [...filteredActivities].sort(_temp);
      const labels = [...new Set(sortedActivities.map(_temp2))];
      const datasets = (["feeding", "pooping", "wee", "sleeping"] as const).map(type => {
        const data = labels.map(label => {
          if (type === "sleeping") {
            return sortedActivities.filter(activity_1 => new Date(activity_1.time).toLocaleDateString() === label && activity_1.type === type).reduce(_temp3, 0);
          }
          return sortedActivities.filter(activity_3 => new Date(activity_3.time).toLocaleDateString() === label && activity_3.type === type).length;
        });
        return {
          label: type.charAt(0).toUpperCase() + type.slice(1),
          data,
          borderColor: type === "feeding" ? cssVar("--chart-1") : type === "pooping" ? cssVar("--chart-2") : type === "wee" ? cssVar("--chart-3") : cssVar("--chart-4"),
          yAxisID: type === "sleeping" ? "y1" : "y"
        };
      });
      return {
        labels,
        datasets
      };
    };
    t1 = processData();
    $[0] = activities;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const data_0 = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      legend: {
        position: "top" as const
      },
      title: {
        display: true,
        text: "Daily Totals"
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: true,
      text: "Count"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      type: "linear" as const,
      display: true,
      position: "left" as const,
      title: t3,
      min: 0,
      ticks: {
        stepSize: 1
      }
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      responsive: true,
      plugins: t2,
      scales: {
        y: t4,
        y1: {
          type: "linear" as const,
          display: true,
          position: "right" as const,
          title: {
            display: true,
            text: "Hours"
          },
          grid: {
            drawOnChartArea: false
          }
        },
        x: {
          title: {
            display: true,
            text: "Date"
          }
        }
      }
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const options = t5;
  let t6;
  if ($[6] !== data_0) {
    t6 = <Line options={options} data={data_0} />;
    $[6] = data_0;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}
function _temp3(total, activity_2) {
  if (activity_2.startTime && activity_2.endTime) {
    const diff = new Date(activity_2.endTime).getTime() - new Date(activity_2.startTime).getTime();
    return total + diff / 3600000;
  }
  return total;
}
function _temp2(activity_0) {
  return new Date(activity_0.time).toLocaleDateString();
}
function _temp(a, b) {
  return new Date(a.time).getTime() - new Date(b.time).getTime();
}